import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

export default function PageTransition({ children }) {
  const location  = useLocation();
  const [phase, setPhase]     = useState('idle'); // idle | out | in
  const [content, setContent] = useState(children);
  const prevKey = useRef(location.key);

  useEffect(() => {
    // Same route — don't animate
    if (location.key === prevKey.current) {
      setContent(children);
      return;
    }

    // New route — animate out, swap, animate in
    setPhase('out');

    const swapTimer = setTimeout(() => {
      setContent(children);
      prevKey.current = location.key;
      setPhase('in');
    }, 180); // matches --pt-duration-out in CSS

    const doneTimer = setTimeout(() => {
      setPhase('idle');
    }, 180 + 280); // out + in

    return () => {
      clearTimeout(swapTimer);
      clearTimeout(doneTimer);
    };
  }, [location.key]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`pt-wrapper pt-wrapper--${phase}`}>
      {content}
    </div>
  );
}
